window.theme.component('footer', el => {
    // Mobile Menu Accordion
    const accordion = el.querySelector('.js-accordion');

    /**
     * Close an item.
     *
     * @param {HTMLElement} item
     */
    function closeItem(item) {
        if (!item.classList.contains('is-active')) return;

        item.classList.remove('is-active');
        item.querySelector('.js-item-content').removeAttribute('style');
    }

    /**
     * Open an item.
     *
     * @param {HTMLElement} item
     */
    function openItem(item) {
        if (item.classList.contains('is-active')) return;

        item.classList.add('is-active');

        updateActiveItemHeight();
    }

    /**
     * Update the active item's height.
     *
     */
    function updateActiveItemHeight() {
        const activeItem = el.querySelector('.js-item.is-active');
        if (!activeItem) return;

        const contentHeight = activeItem.querySelector('.js-item-content-wrapper').clientHeight;
        activeItem.querySelector('.js-item-content').style.height = `${contentHeight}px`;
    }

    // Detect clicks on the accordion.
    if (accordion) {
        accordion.addEventListener('click', ({target}) => {
            const toggle = target.closest('.js-item-toggle');
            if (!toggle) return;

            // Get the item this toggle belongs to.
            const item = toggle.parentNode;

            // Close the item if it's already active.
            if (item.classList.contains('is-active')) {
                closeItem(item);
            } else {
                // Close the currently active item.
                const activeItem = el.querySelector('.js-item.is-active');
                if (activeItem) closeItem(activeItem);

                // Open the item.
                openItem(item);
            }
        });
    }

    // Update the active item's height when the window is resized.
    let updateTimeout = false;

    window.addEventListener('resize', () => {
        clearTimeout(updateTimeout);
        updateTimeout = setTimeout(() => updateActiveItemHeight(), 150);
    });
});